"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExternalSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.92 2.62a1 1 0 00-.54-.54A1 1 0 0029 2h-8a1 1 0 100 2h5.6L12.29 18.3a1 1 0 000 1.41A1 1 0 0013 20a1 1 0 00.7-.29L28 5.4V11a1 1 0 102 0V3a1 1 0 00-.08-.38z"/><path d="M27 19a1 1 0 00-1 1v8H4V6h9a1 1 0 000-2H4a2 2 0 00-2 2v22a2 2 0 002 2h22a2 2 0 002-2v-8a1 1 0 00-1-1z"/>';
var ExternalSVG = function ExternalSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ExternalSVG = ExternalSVG;
ExternalSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ExternalSVG);
exports.default = _default;